import { HqlCode } from '@/components/hql/HqlCode';
import { TableCell, TableHead } from '@/components/ui/table';
import { describeCoveredUnits } from '@/lib/hqlFormat';
import type { HomeEvalResult } from '@rock/types';
import { homeEvalApplied, homeEvalAppliedSummary } from '@rock/util';
import type { FC } from 'react';
import { AiIsPossible } from './HomeEvalAiDetails';

export const HomeEvalOutcomeHeads: FC = () => (
    <>
        <TableHead>Covers</TableHead>
        <TableHead>Why</TableHead>
        <TableHead>Possible (AI)</TableHead>
    </>
);

/**
 * One result's cells under `HomeEvalOutcomeHeads`: what the created consideration covers and the query
 * behind it, or for a retired AI result, what the model applied and its summary.
 */
export const HomeEvalOutcomeCells: FC<{ result: HomeEvalResult }> = ({ result }) => {
    if (result.schema === 2) {
        return (
            <>
                <TableCell>
                    <span className="text-green-600">
                        {describeCoveredUnits(result.coveredEquipmentIds, result.facts.equipment)}
                    </span>
                </TableCell>
                <TableCell className="max-w-md truncate">
                    <HqlCode query={result.query} />
                </TableCell>
                <TableCell />
            </>
        );
    }
    return (
        <>
            <TableCell>
                <span className={homeEvalApplied(result.aiResponse) ? 'text-green-600' : 'text-gray-600'}>
                    {homeEvalAppliedSummary(result.aiResponse)}
                </span>
            </TableCell>
            <TableCell className="max-w-md truncate">{result.aiResponse.summary}</TableCell>
            <TableCell>
                <AiIsPossible possible={result.aiResponse.isPossible} />
            </TableCell>
        </>
    );
};
